module.exports = __webpack_public_path__ + "assets/img/333.baf0934e.jpg";